module.exports = __webpack_public_path__ + "static/img/img10.d376a52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aifv/img10.png
// module id = TdLL
// module chunks = 1